import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "@/components/Sidebar";
import { useI18n } from "@/lib/i18n";
import { Menu, Sun, Moon } from "lucide-react";

export function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dark, setDark] = useState(document.documentElement.classList.contains("dark"));
  const { lang, setLang } = useI18n();

  const toggleTheme = () => {
    const el = document.documentElement;
    const next = !el.classList.contains("dark");
    el.classList.toggle("dark", next);
    localStorage.setItem("cd-theme", next ? "dark" : "light");
    setDark(next);
  };

  return (
    <div className="App flex min-h-screen">
      <Sidebar mobileOpen={mobileOpen} onClose={() => setMobileOpen(false)} />
      <div className="flex-1 min-w-0 flex flex-col">
        <header className="sticky top-0 z-30 h-14 bg-card/90 backdrop-blur-xl border-b border-border flex items-center justify-between px-4">
          <button data-testid="mobile-menu-btn" className="md:hidden w-10 h-10 rounded-full bg-muted flex items-center justify-center" onClick={() => setMobileOpen(true)}><Menu className="w-5 h-5" /></button>
          <div className="flex-1" />
          <div className="flex items-center gap-1 bg-muted rounded-full p-1 mr-2">
            {["es", "ca", "en"].map((l) => (
              <button key={l} data-testid={`lang-${l}`} onClick={() => setLang(l)} className={`px-2.5 py-1 rounded-full text-xs font-bold uppercase ${lang === l ? "bg-primary text-primary-foreground" : "hover:bg-card"}`}>{l}</button>
            ))}
          </div>
          <button data-testid="theme-toggle-btn" onClick={toggleTheme} className="w-10 h-10 rounded-full bg-muted hover:bg-accent flex items-center justify-center transition-colors">{dark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}</button>
        </header>
        <main className="flex-1 px-4 sm:px-8 py-8 max-w-[1400px] w-full mx-auto"><Outlet /></main>
      </div>
    </div>
  );
}
